import { receiptDataLayer, receiptEvents } from './analiticsObject';
import { isMobile } from 'react-device-detect';

export function gaNewLandingAccess(storeId, language) {
  const rdl = new receiptDataLayer();
  rdl.push(receiptEvents.FRONT_GA_PAGE_VIEW, {
    pageType: 'LANDING_STORE',
    page: {
      shop: storeId,
      language,
      application: isMobile ? 'web-mobile' : 'web-pc',
    },
  });
}

export function gaNewDownloadApp(operatingSystem) {
  const rdl = new receiptDataLayer();
  rdl.push(receiptEvents.FRONT_LANDING_STORE_DOWNLOAD_APP, {
    operatingSystem,
  });
}

export function gaChangeLanguage(language) {
  const rdl = new receiptDataLayer();
  rdl.push(receiptEvents.FRONT_LANDING_STORE_CHANGE_LANGUAGE, {
    selectedOption: language,
  });
}

export function gaSectionAccess(storeId, language, floor, section) {
  const rdl = new receiptDataLayer();
  rdl.push(receiptEvents.FRONT_GA_PAGE_VIEW, {
    pageType: 'LANDING_STORE_SECTION',
    page: {
      shop: storeId,
      language,
      floor,
      section,
      application: isMobile ? 'web-mobile' : 'web-pc',
    },
  });
}

export function gaSubSectionAccess(storeId, language, floor, section, url) {
  const rdl = new receiptDataLayer();
  rdl.push(receiptEvents.FRONT_GA_PAGE_VIEW, {
    pageType: 'LANDING_STORE_SUBSECTION',
    page: {
      shop: storeId,
      language,
      floor,
      section,
      application: isMobile ? 'web-mobile' : 'web-pc',
      url,
    },
  });
}
